import styled from "styled-components";
import { Link } from "react-router-dom";
import { colors } from "../../consts";
import { Paragraph2 } from "../Text/Paragraphs";

export const LinkStyled = styled(Link)`
  width: 100%;

  border-left: ${(props) =>
    props?.active ? `2px solid ${colors.TURQUOISE_100}` : "2px solid transparent"};

  opacity: 1;

  background: none;
  padding: unset;

  * {
    transition: all 0s;
  }

  &:hover {
    opacity: 1;

    ${Paragraph2} {
      color: ${colors.ISABELLINE};
    }
  }

  ${Paragraph2} {
    font-weight: 500;
    font-size: 10px;
    line-height: 10px;

    text-align: center;
    width: max-content;

    color: ${(props) => (props?.active ? colors.ISABELLINE : colors.RAISIN_50)};
  }

  ${(props) => props?.disabled && "pointer-events: none;"}
`;
